export default "__VITE_ASSET__COL$$0Zp__"